/** @module Validators */

/**
 * @type {String}
 * @private
 * @const
 */
export var ERROR = 'must_be_number';
/**
 * Creates validator for number values
 *
 * @function number
 * @return {validator} number validator
 */

export default function number() {
  return function (value) {
    if (value && !value.toString().match(/^(-)?\d+((,|\.)\d+)?$/)) return ERROR;
    return null;
  };
}